import type { Nullable } from "../../../typescript"
import type { EntityTypeId } from "./EntityTypeId.enum"
import { waterEntityTypeIdList } from "./waterEntityTypeIdList"

/**
 * requirements
 * - A "water" entity is one that which a shoal entity will "dip" into.
 * 
 * @param entity 
 * @returns boolean
 */
export default function isEntityTypeIdWater(entityTypeId: Nullable<EntityTypeId>) {
  return waterEntityTypeIdList.includes(entityTypeId!)
}